import React, { useEffect, useState } from 'react'

interface LoaderProps {
  heading: string
  steps: string[]
  nextPage: string
  onComplete: () => void
}

export const Loader: React.FC<LoaderProps> = ({
  heading,
  steps,
  onComplete,
}) => {
  const [currentStep, setCurrentStep] = useState(0)

  useEffect(() => {
    if (!steps || steps.length === 0) {
      // Auto-complete after 2 seconds if no steps
      const timer = setTimeout(() => {
  onComplete()
      }, 2000)
      return () => clearTimeout(timer)
    }

    // Cycle through steps
    const stepDuration = 1500 // 1.5 seconds per step
    const totalDuration = steps.length * stepDuration

    const stepIntervals: NodeJS.Timeout[] = []

    steps.forEach((_, index) => {
      const timer = setTimeout(() => {
        setCurrentStep(index)
      }, index * stepDuration)
      stepIntervals.push(timer)
    })

    // Complete after all steps
    const completeTimer = setTimeout(() => {
      onComplete()
    }, totalDuration)

    return () => {
      stepIntervals.forEach(t => clearTimeout(t))
      clearTimeout(completeTimer)
    }
  }, [steps, onComplete])

  return (
    <div className="quiz-loading-page">
      <div className="loader-container">
        <h2>{heading}</h2>

        {/* Animated Spinner */}
        <div className="spinner-wrapper">
          <div className="spinner"></div>
        </div>

        {/* Steps Progress */}
        {steps && steps.length > 0 && (
          <div className="steps-container">
            {steps.map((step, index) => (
              <div
                key={index}
                className={`step ${index <= currentStep ? 'active' : ''} ${index < currentStep ? 'complete' : ''}`}
              >
                <span className="step-icon">
                  {index < currentStep ? '✓' : '○'}
                </span>
                <span className="step-text">{step}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
